module.exports = __webpack_public_path__ + "static/img/course_ware.5ef343d6.png";